module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"network-error":"Network error. Please try to refresh this page."},"fi":{"network-error":"Ongelma verkkoyhteydessä. Yritä uudelleenladata tämä sivu."},"sv":{"network-error":"Nätverksfel. Försök att uppdatera den här sidan."},"de":{"network-error":"Netzwerkfehler. Bitte versuchen Sie, diese Seite zu aktualisieren."},"ko":{"network-error":"네트워크 오류. 이 페이지를 새로고침해 보세요."}}')
  delete Component.options._Ctor
}
